import { Component, OnInit, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { FaqCategory } from '../faq.model';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'jhi-faq-category',
  templateUrl: './faq-category.component.html',
  styleUrls: ['./faq-category.component.scss']
})
export class FaqCategoryComponent implements OnInit, AfterViewInit, OnDestroy {

  private fragment: string;

  private frangementSub$: Subscription;

  @Input()
  category: FaqCategory;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.frangementSub$ = this.route.fragment.subscribe(fragment => { this.fragment = fragment; });
  }

  ngAfterViewInit(): void {
      try {
        if (document.querySelector('#' + this.fragment) != null) {
          document.querySelector('#' + this.fragment).scrollIntoView();
        }
      } catch (e) {
        console.error(e);
      }
  }

  ngOnDestroy(): void {
      this.frangementSub$.unsubscribe();
  }

}




// WEBPACK FOOTER //
// ./src/main/webapp/app/faq/faq-category/faq-category.component.ts